import { Link } from "react-router-dom";
import { SocialIcons, useSocialLinks } from "@/components/SocialLinks";
import { useCurrency } from "@/context/CurrencyContext";

const FOOTER_HEADING = "Ignota Pars";
const FOOTER_DESCRIPTION =
  "Modern garments of quiet intent. Designed in the studio, made to endure — a wardrobe stripped to its most essential form.";

export const Footer = () => {
  const social = useSocialLinks();
  const { homepage } = useCurrency();
  return (
    <footer data-testid="footer" className="bg-black border-t border-white/10 mt-32">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <h3 data-testid="footer-brand-heading" className="font-serif-display text-3xl tracking-[0.15em] uppercase mb-4">{homepage?.footer_heading || FOOTER_HEADING}</h3>
          <p data-testid="footer-brand-description" className="text-white/50 max-w-sm text-sm leading-relaxed whitespace-pre-line">
            {homepage?.footer_description || FOOTER_DESCRIPTION}
          </p>
        </div>
        <div>
          <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-5">Explore</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/collection" className="hover:text-white transition-colors">Collection</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-5">Legal</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/legal/terms" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/legal/shipping" className="hover:text-white transition-colors">Shipping Policy</Link></li>
            <li><Link to="/legal/returns" className="hover:text-white transition-colors">Returns & Refunds</Link></li>
            <li><Link to="/legal/imprint" className="hover:text-white transition-colors">Imprint</Link></li>
          </ul>
        </div>
        {social.length > 0 && <div>
          <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-5">Follow</p>
          <SocialIcons links={social} size={20} testPrefix="social" linkClass="hover:text-white transition-colors" />
        </div>}
      </div>
      <div className="border-t border-white/10 py-6 px-6 lg:px-12 flex flex-col md:flex-row justify-between gap-3 text-xs font-mono-label uppercase tracking-luxe text-white/30">
        <span>© {new Date().getFullYear()} Ignota Pars</span>
        <span>Crafted with intent</span>
      </div>
    </footer>
  );
};
